import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import type { DisplayProps, JustifyContentProps, SpaceProps } from 'styled-system';
import { display, justifyContent, space } from 'styled-system';

import type { ArticleEntity } from './Article';
import Article, { NavigationType } from './Article';

export interface ArticlesNavigationProps {
  prevArticle: Nullable<ArticleEntity>;
  nextArticle: Nullable<ArticleEntity>;
}

const ArticleList = styled.ul<DisplayProps & JustifyContentProps & SpaceProps>`
  ${display};
  ${justifyContent};
  ${space};
`;

const articleListStyles: ComponentProps<typeof ArticleList> = {
  display: 'flex',
  p: 0,
  m: 0,
};

const ArticlesNavigation = ({ prevArticle, nextArticle }: ArticlesNavigationProps) => {
  const hasArticles = prevArticle || nextArticle;

  return (
    hasArticles && (
      <nav data-corgi-id="articles-navigation">
        <ArticleList
          {...articleListStyles}
          justifyContent={!prevArticle ? 'flex-end' : 'space-between'}
        >
          {prevArticle && (
            <Article {...prevArticle} type={NavigationType.Previous} withMaxWidth={!!nextArticle} />
          )}
          {nextArticle && (
            <Article {...nextArticle} type={NavigationType.Next} withMaxWidth={!!prevArticle} />
          )}
        </ArticleList>
      </nav>
    )
  );
};

export default ArticlesNavigation;
